// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"363":"7648bbfd","540":"115de207"}[chunkId] + ".css";
};